import { useTheme } from "../../context/ThemeContext";

export default function DashboardCard({
  title,
  value,
  subtitle,
}) {

  const { isDark } = useTheme();

  return (
    <div
      className={`
        relative
        overflow-hidden
        rounded-3xl
        border
        p-6
        transition-all
        duration-300
        hover:scale-[1.02]
        ${
          isDark
            ? `
              bg-white/5
              border-white/10
              backdrop-blur-xl
            `
            : `
              bg-white
              border-gray-200
              shadow-sm
            `
        }
      `}
    >

      {isDark && (
        <div
          className="
            absolute
            top-0
            right-0
            w-24
            h-24
            bg-blue-800/10
            rounded-full
            blur-2xl
          "
        />
      )}

      <p
        className={
          isDark
            ? "text-gray-400"
            : "text-gray-500"
        }
      >
        {title}
      </p>

      <h3
        className="
          mt-3
          text-4xl
          font-bold
        "
      >
        {value}
      </h3>

      {subtitle && (
        <p
          className="
            mt-3
            text-sm
            text-blue-800
          "
        >
          {subtitle}
        </p>
      )}

    </div>
  );
}